/**
 * The language preference itself — the one screen that MUST read in the language being chosen, so
 * somebody who has landed on the wrong one can get themselves out.
 */
export default {
  languageTitle: 'Language',
  languageHelp: 'Which language this application is shown to you in. Anything not yet translated is '
    + 'shown in English.',
  useMyDeviceLanguage: 'Use my device’s language',
  useMyDeviceLanguageHelp: 'No choice saved — your phone or computer decides, and your company’s '
    + 'setting decides if it has no answer.',
  languageSaved: 'Language saved',
  languageSaveFailed: 'That could not be saved. Try again.',
  // Admin-facing: setting it FOR somebody during onboarding.
  languageForUser: 'Language',
  languageForUserHelp: 'What this person reads. Set it here if they cannot read the screen where '
    + 'they would set it themselves.',
  notChosen: 'Not set',
  companyDefaultLanguage: 'Company language',
  companyDefaultLanguageHelp: 'What everybody sees — including the sign-in page, before anybody has '
    + 'signed in. A person’s own setting always wins over this.',
  noCompanyDefault: 'No company language',
  // There are TWO company-wide language settings and they answer different questions for different
  // people. This one is for anybody who signs in; the QR sticker sheet is read by field hands who
  // have no account at all, so it has its own, under Forms. Neither used to mention the other, so an
  // admin could set this and reasonably believe the sheets on the machines had moved as well.
  companyDefaultLanguageNotStickers: 'This is for people who sign in. The QR sticker sheet is read '
    + 'by people who do not, so it has its own starting language under Forms → Signing rules.',
}
